// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freemium-filter__badge{display:inline-flex;align-items:center;font-size:14px;line-height:22px;letter-spacing:.2px;font-weight:700;text-align:center;color:#fff;background:linear-gradient(-225deg,#5c6374,#3b404e 31%,#272939 68%,#191d2a);padding:2px 7px;border-radius:4px;-webkit-margin-start:8px;margin-inline-start:8px}.freemium-filter__badge--sm{padding:2px 6px;font-size:12px;line-height:16px}.freemium-filter__badge svg{-webkit-margin-end:8px;margin-inline-end:8px}", ""]);
// Exports
module.exports = exports;
